<template>
    <div class="">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" @click="dashboard">
                        <img src="../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Notifikasi</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="w-limit">
<div class="wrapper-more">
    <button type="button" class="btn btn-primary btn-more animated pulse infinite " @click="toMenuEkspor" >Cadangkan Sekarang</button>
</div>
                    <div class="main-pnotif  p-t-16 p-d-20 p-x-20">
                            <div class="category-pnotif">
                                Pemberitahuan
                            </div>
                            <div class="title-pnotif">
                                Cadangkan Data
                            </div>
                            <div class="subtitle-pnotif">
                                6 Jan 2020 / 23:00
                            </div>

                        <div  class="desc-pnotif"> Tim smartlink akan melakukan <b > update integrasi data SmartOwner </b>pada hari <b >Kamis, 7 Januari 2021 pukul 23.00 WIB.</b><br > Karena ada kemungkinan data akan <b >tersembunyi &amp; tidak muncul</b> di SmartOwner maupun di Kasir, mohon untuk para smartowner melakukan <b >pencadangan (backup) data</b> dengan ekspor (download) <b >Data layanan reguler, Data paket deposit &amp; Data saldo deposit Konsumen.</b> </div>

                        <div  class="desc-pnotif" style="border: 1px solid rgb(247, 157, 187); padding: 20px; background: rgb(255, 246, 249); margin-bottom: 20px;">Anda dapat <b >mulai</b> melakukan pencadangan data pada <b >Rabu, 6 Januari 2021 jam 14.00 WIB - Kamis, 7 Januari 2021 22.30 WIB. </b><br > Pastikan Anda telah mencadangkan semua data yang dianggap penting, agar dapat mencocokan jika ada ketidaksesuaian.  Klik Menu dibawah ini untuk mencadangkan sekarang. <br > Mohon maaf atas ketidaknyamanannya.</div>

                                <div class="menu-pnotif">
                                    <!-- Main konten -->
                                    <div class="section-keuangan-main">
                                        <div class="section-keuangan-wrapper">
                                            <div class="m-t-12 inner-panel" >
                                                <div class="inner-panel-item" @click="goRouteNotif('backup-layanankuy')">
                                                    <div class="f-14 f-c-midgrey">Cadangkan Per Outlet</div>
                                                    <div class="f-16 f-semi">Layanan Reguler</div>
                                                </div>
                                                <div class="inner-panel-item" @click="goRouteNotif('backup-depositkuy')">
                                                    <div class="f-14 f-c-midgrey">Cadangkan Per Outlet</div>
                                                    <div class="f-16 f-semi">Paket Deposit</div>
                                                </div>
                                                <div class="inner-panel-item">
                                                    <div class="overloading" v-if="resumeonprogress">
                                                        <div class="overloading-text">Sedang Memuat Data ...</div>
                                                    </div>

                                                    <div  @click="exportResumeDeposit">
                                                        <div class="f-14 f-c-midgrey" >Cadangkan Per Owner</div>
                                                        <div class="f-16 f-semi">Saldo Deposit Konsumen</div>

                                                    </div>

                                                    <div v-if="exportlink">
                                                        <span style="font-size: 14px; color : #A00;">
                                                        Jika file download tidak muncul secara otomatis,
                                                        </span>
                                                        <br/>
                                                        <a :href="exportlink" >Klik Download Disini</a>
                                                    </div>
                                                </div>
                                                <div id="end-menu-ekspor">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                    </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Ibos",
        data() {
            return {
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                resumeonprogress:0,
                textprogress:"",
                timerprogress:null,
                exportlink:0,
            }
        },
        mounted() {
            let visible= this.checkVisible("#end-menu-ekspor")

            if(visible){
                $(".btn-more").hide();
            }else{
                $(".btn-more").show();
            }
            this.scroll()
        },

        methods: {
            goRouteNotif: function (route) {
                this.$router.push({name: route})
            },
            async exportResumeDepositBackground() {
                this.resumeonprogress=1

                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/deposit/export_resume_deposit_customer', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            let that=this
                            this.timerprogress=setInterval(function () {
                                that.checkExportBackground();
                                },2000)
                            // this.deleteStorage(filenameStorage);

                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.resumeonprogress=0
                }
            },
            async checkExportBackground() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/deposit/tracking_export_resume_deposit_customer', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var dataprogress = response.data.data;
                            if(dataprogress.status_progress==="1"){

                                this.resumeonprogress=0

                                window.clearInterval(this.timerprogress);
                                var filenameStorage = response.data.data.filename

                                var linkStorage = response.data.data.link_file_storage
                                linkStorage = linkStorage.replace(filenameStorage,encodeURIComponent(filenameStorage));
                                window.open(linkStorage, "_blank");
                                this.exportlink=linkStorage
                                // this.deleteStorage(filenameStorage);

                            }
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    }

                    this.resumeonprogress=0

                } catch (e) {
                    this.$catch_error_response(e)
                    this.resumeonprogress=0
                }
            },

            async exportResumeDeposit() {
                this.resumeonprogress=1

                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/deposit/direct_export_resume_deposit_customer', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var filenameStorage = response.data.data.filename
                            var linkStorage = response.data.data.link_file_storage
                            linkStorage = linkStorage.replace(filenameStorage,encodeURIComponent(filenameStorage));
                            window.open(linkStorage, "_blank");
                            this.exportlink=linkStorage
                            // this.deleteStorage(filenameStorage);
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    }

                    this.resumeonprogress=0

                } catch (e) {
                    this.$catch_error_response(e)
                    this.resumeonprogress=0
                }
            },

            async deleteStorage(filename) {
                try {
                    var formData = new FormData()
                    formData.append("filename", filename)

                    const response = await this.$axios.post(this.$baseurl + '/masterData/layanan/delete_file_export_layanan?filename=' + filename, formData, this.requestHeaders)
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            dashboard() {
                this.$router.push({name: 'dashboard'})
            },
            toMenuEkspor(){
                $('html, body').animate({
                    scrollTop: $("#end-menu-ekspor").offset().top
                }, 1000);
            },
            scroll() {
                window.onscroll = () => {
                    let visible= this.checkVisible("#end-menu-ekspor")

                    if(visible){
                        $(".btn-more").hide();
                    }else{
                        $(".btn-more").show();
                    }
                }
            },
            checkVisible(elm,evalType){

                    evalType = evalType || "visible";

                    var vpH = $(window).height(), // Viewport Height
                        st = $(window).scrollTop(), // Scroll Top
                        y = $(elm).offset().top,
                        elementHeight = $(elm).height();

                    if (evalType === "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
                    if (evalType === "above") return ((y < (vpH + st)));
            }

        }

    }

    // alert($(".nav-bottom--inner").outerHeight())

</script>


<!-- Style css -->
<style scoped>

    .overloading {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #686868ed;
        z-index: 9;
        text-align: center;
        color: #fff;
        padding-top: 20px;
        font-size: 18px;
    }
    .inner-panel-item{
        position: relative;
    }

    .wrapper-more {
        z-index: 9;
        position: fixed;
        bottom: 100px;
        left: 0px;
        right: 0px;
        width: 100%;
        text-align: center;
    }


    .category-pnotif {
        color: #4A85FF;
        font-size: 12px;
    }

    .title-pnotif {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 4px;
    }

    .subtitle-pnotif {
        color: #6F7287;
        font-size: 12px;
        margin-bottom: 16px;
    }

    .desc-pnotif {
        margin: 0px 0px;
        padding: 20px 0px;
        font-size: 16px;
        color:  #333333;
        border-top: dashed 1px #cacaca;
        line-height: 155%;
        /* or 25px */
        letter-spacing: -0.02em;
    }

    .circular--portrait img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    .paylink-panel .paylink-top-panel {
        background: linear-gradient(270deg, #4CA1AF 0%, #1C54C4 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 41px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .paylink-panel .paylink-balance {
        color: white;
        font-weight: 600;
    }

    .paylink-panel .paylink-bottom-panel {
        display: flex;
        justify-content: space-around;
        padding: 8px 0px;
    }

    .paylink-panel .paylink-bottom-panel .icon-panel {
        width: 28px;
        height: 28px;
        margin: auto;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }


    .inner-panel {
        border: 1px solid #EDEDED;
        border-radius: 3px;
    }

    .inner-panel .inner-panel-item {
        padding: 12px 48px 12px 16px;
        position: relative;
    }

    .inner-panel .inner-panel-item:not(:first-child),
    .inner-panel .inner-panel-12:not(:first-child) {
        border-top: 1px solid #EDEDED;
    }

    .splide-wrapper .splide__slide img {
        vertical-align: middle;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    .splide-wrapper.splide-info .splide__slide img {
        height: 120px;
        border-bottom: 1px solid #C8D0DD;
    }
</style>